import { cn } from '@/lib/utils/utils';
import { Crown } from 'lucide-react';

export function ZangiaPlusMemberBadge({
  className,
}: {
  className?: string;
}) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-700 text-white">
        <Crown className="h-3 w-3" />
      </span>
      <span className="text-xs text-primary font-normal">Zangia Plus</span>
    </div>
  );
}
